import { createSlice } from "@reduxjs/toolkit"
import { pageFormObject } from "@form/pageFormFields"

const pagesSlice = createSlice({
  name: 'pages',
  initialState: {
    pages: null,
    pageTypes: [],
    pageFormObject: { ...pageFormObject },
    errors: []
  },
  reducers: {
    fullUpdate: (state, action) => {
      return { ...state, ...action.payload }
    },
    updatePageFormObject: (state, action) => {
      state.pageFormObject = action.payload
    },
    addPage: (state, action) => {
      const page = action.payload
      state.pages = { ...state.pages, [page.id]: page }
    },
    updatePages: (state, action) => {
      state.pages = action.payload
    },
    updateErrors: (state, action) => {
      state.errors = action.payload
    }
  }
})

export const { fullUpdate, updatePageFormObject, addPage, updatePages, updateErrors } = pagesSlice.actions

export default pagesSlice.reducer